import selectPositionModalTemplate from '../views/modals/select-positions-modal.tpl.html';

class CreateModalCtrl {
    constructor(Contact, $uibModal, $uibModalInstance, InvoiceTemplate, entity, type, $scope, Invoice, $q, NumberCircle, SweetAlert, Error, $rootScope, $http, $filter) {
        this.contactModel = Contact;
        this.modal = $uibModal;
        this.uibModalInstance = $uibModalInstance;
        this.invoiceTemplateModel = InvoiceTemplate;
        this.invoiceModel = Invoice;
        this.numberCircleModel = NumberCircle;
        this.givenEntity = entity;
        this.givenType = type;
        this.scope = $scope;
        this.q = $q;
        this.sweetAlert = SweetAlert;
        this.error = Error;
        this.rootScope = $rootScope;
        this.api = $http;
        this.filter = $filter;

        this.initVars();

        this.loadOpenPositions();
        this.loadContact();
        this.loadInvoiceTemplates();
        this.loadNumberCircles();
        this.initWatchers();
    }

    initVars() {
        this.positions = [];
        this.template = {};
        this.contact = false;
        this.blockSubmit = false;

        this.model = {
            extended: {},
            ignore_positions: []
        };
        this.currentBillables = [];
        this.invoiceTemplates = [];
        this.address_type = 'default';
        this.addressFromLastDocument = '';
        this.addressEditable = false;
        this.numberCircles = [];
        this.positionGroups = [];
        this.currentGroupIndex = 0;
        this.currentActiveGroup = {};
    }

    loadContact() {
        this.contactModel.one(this.givenEntity.contactId).get({include: 'invoices'}).then((contact) => {
            this.contact = contact.plain();
            this.address_type = 'default';
            this.updateAddress(this.address_type);
        });
    }

    loadNumberCircles() {
        this.numberCircleModel.getList().then((circles) => {
            this.numberCircles = [];
            _.forEach(circles, (v, k) => {
                this.numberCircles.push({
                    id: v.id,
                    title: v.title
                });
            });

            // this.model.number_circle_id = this.numberCircles[0].id;
        });
    }

    loadOpenPositions() {
        this.api.get('billing/invoices/' + this.givenEntity.type + '/' + this.givenEntity.id + '/positions/' + this.givenType).then((response) => {
            this.positionGroups = _.cloneDeep(response.data.data);
            this.model.extended = {};
            _.each(this.positionGroups, (group, groupKey) => {
                this.positionGroups[groupKey].address_type = 'default';

                let currentOrder = 1;
                _.each(group.positions, (position, positionKey) => {
                    this.positionGroups[groupKey].positions[positionKey].enabled = true;
                    this.positionGroups[groupKey].positions[positionKey].order = currentOrder++;
                });

                this.model.extended[group.identifier] = {
                    invoice_date: new Date(),
                    shipping: true
                }
            });

            this.updateExtendedInformationOnAllDocuments();
            if (this.positionGroups.length === 0) {
                this.sweetAlert.info('No Positions', 'Currently there are no open positions available');
                this.close();
            } else {
                this.activateGroup(this.positionGroups[0]);
            }
        }, () => {
            this.sweetAlert.info('No Positions', 'Currently there are no open positions available');
            this.close();
        });
    }

    loadInvoiceTemplates() {
        this.invoiceTemplateModel.getList().then((collection) => {
            _.forEach(collection, (v, k) => {
                if (v['enable_for_' + this.givenType]) {
                    this.invoiceTemplates.push(v.plain());
                }
            });

            this.template = this.invoiceTemplates[0];
        });
    }

    initWatchers() {
        this.scope.$watch(() => {
            return this.template;
        }, (value) => {
            this.model.invoice_template_id = value.id;
            this.updateExtendedInformationOnAllDocuments();
        });

        this.scope.$watch(() => {
            return this.address_type;
        }, (value) => {
            this.currentActiveGroup.address_type = value;
            this.updateAddress(value);
        });

        this.scope.$watch(() => {
            return this.positionGroups;
        }, (value) => {
            this.reArrangePositionsOrder();
        }, true);
    }

    updateAddress(value) {
        this.addressEditable = (value === 'custom');
        if (!this.contact || !this.currentActiveGroup.identifier) {
            return;
        }

        if (value === 'last_document') {
            this.model.extended[this.currentActiveGroup.identifier].address = this.addressFromLastDocument;
        } else if (value !== 'custom') {
            let addressPrefix;
            switch (value) {
                case 'preferred':
                    addressPrefix = 'preferred_';
                    break;
                case 'private':
                    addressPrefix = '';
                    break;
                case 'business':
                    addressPrefix = 'business_';
                    break;
                case 'shipping':
                    addressPrefix = 'shipping_';
                    break;
                case 'default':
                    console.log('test');
                    this.model.extended[this.currentActiveGroup.identifier].address = '';
                    return;
            }

            let address = '';
            if (value === 'business' || (value === 'preferred' && this.contact.business_preferred)) {
                address += (this.contact.company_name).trim();
                if (address !== '') {
                    address += "\n";
                }
                const nameString = (this.contact.title + ' ' + this.contact.first_name + ' ' + this.contact.last_name).trim();
                if (nameString !== '') {
                    address += 'z. H. ' + nameString + "\n";
                }
            } else {
                address += (this.contact.title + ' ' + this.contact.first_name + ' ' + this.contact.last_name).trim() + "\n";
            }

            address += this.contact[addressPrefix + 'street'] + "\n";
            if(this.contact[addressPrefix + 'street_2']) {
                address += this.contact[addressPrefix + 'street_2'] + "\n";
            }
            address += this.contact[addressPrefix + 'zip'] + ' ' + this.contact[addressPrefix + 'city'] + "\n";

            let countryName = '';
            if (this.contact[addressPrefix + 'country']) {
                let currentCountryCode = this.contact[addressPrefix + 'country'].toUpperCase();
                if (currentCountryCode) {
                    currentCountryCode = currentCountryCode.toUpperCase();
                    _.forEach(this.rootScope.deposit.countries, (country) => {
                        if (country.code === currentCountryCode) {
                            countryName = country.name;
                        }
                    });
                }
            }

            if (countryName) {
                address += (countryName + "\n").trim();
            }

            this.model.extended[this.currentActiveGroup.identifier].address = address;
        }
    }

    close() {
        this.uibModalInstance.close();
    }

    save() {
        const dataToSend = _.cloneDeep(this.model);
        dataToSend.positions = {};

        _.each(this.positionGroups, (group) => {
            dataToSend.positions[group.identifier] = [];
            _.each(this.filter('filter')(group.positions, {enabled: true}), (position) => {
                dataToSend.positions[group.identifier].push({
                    position_link_id: position.id ? position.id : null,
                    position_id: position.position_id ? position.position_id : null,
                    label: position.label,
                    description: position.description,
                    price_per_unit: position.price_per_unit,
                    amount: position.amount,
                    unit: position.unit,
                    order: position.order,
                    tax_rate: position.tax_rate,
                    billable_id: position.billable_id,
                    billable_type: position.billable_type,
                });
            });
        });

        this.blockSubmit = true;
        this.api.post('billing/invoices/' + this.givenEntity.type + '/' + this.givenEntity.id + '/' + this.givenType, dataToSend).then((response) => {
            let invoiceNumbers = [];
            _.each(response.data.data, (invoice) => {
                invoiceNumbers.push(invoice.number);
            });

            this.sweetAlert.success('Success', 'The invoices (' + invoiceNumbers.join(', ') + ') have been created successfully');
            this.close();
        }, (e) => {
            this.error.default(e);
            this.blockSubmit = false;
        });
    }

    activateGroup(positionGroup) {
        this.currentGroupIndex = this.positionGroups.indexOf(positionGroup);
        this.currentActiveGroup = positionGroup;
        this.address_type = this.currentActiveGroup.address_type;
        this.prepareCurrentBillables();
    }

    prepareCurrentBillables() {
        this.currentBillables = [];
        _.each(this.currentActiveGroup.billables, (billable) => {
            switch (billable.type) {
                case 'rsvp':
                    this.currentBillables.push({
                        id: billable.id,
                        type: 'rsvp',
                        label: 'Booking #' + billable.id + ' on guestlist ' + billable.guestlist.name
                    });
                    break;
                case 'rsvp_seatplan_element':
                    this.currentBillables.push({
                        id: billable.id,
                        type: 'rsvp_seatplan_element',
                        label: 'Table ' + billable.label + ' of booking #' + billable.rsvp.id + ' on guestlist ' + billable.rsvp.guestlist.name
                    });
                    break;
                case 'contact':
                    this.currentBillables.push({
                        id: billable.id,
                        type: 'contact',
                        label: billable.customer_number + ': ' + billable.full_name
                    });
                    break;
            }
        });
    }

    removePosition(position) {
        this.positions.splice(this.positions.indexOf(position), 1);
    }

    updateExtendedInformationOnAllDocuments() {
        if (!this.template || this.positionGroups.length <= 0) {
            return;
        }

        const fieldsToCopyFromTemplate = [
            'subject',
            'number_circle_id',
            'text1',
            'text2',
            'text3',
            'tax_rate',
            'processing_costs_per_person',
            'processing_costs_general'
        ];

        _.each(this.positionGroups, (group) => {
            _.each(fieldsToCopyFromTemplate, (fieldName) => {
                this.model.extended[group.identifier][fieldName] = this.template[fieldName];
            });
        });
    }

    addPosition() {
        this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: selectPositionModalTemplate,
            size: 'md',
            controller: 'BillingSelectPositionController',
            controllerAs: 'vm'
        }).result.then((data) => {
            this.currentActiveGroup.positions.push({
                needsCreation: true,
                enabled: true,
                order: this.getCurrentActivePositionsOrdered().length + 1,
                position_id: data.id,
                label: data.label,
                type: data.type,
                child_positions: data.child_positions,
                description: data.description,
                price_per_unit: data.price_per_unit,
                unit: data.unit,
                tax_rate: data.tax_rate,
                amount: 1,
                billable: (this.currentBillables.length > 0) ? this.currentBillables[0] : null,
                billable_type: (this.currentBillables.length > 0) ? this.currentBillables[0].type : null,
                billable_id: (this.currentBillables.length > 0) ? this.currentBillables[0].id : null
            });
        }, () => {

        });
    }

    moveUp(position) {
        if (position.order > 1) {
            let oldOrder = position.order;
            _.each(this.getCurrentActivePositionsOrdered(), (curPos) => {
                if (curPos.order === oldOrder - 1) {
                    curPos.order++;
                }
            });
            position.order--;
        }
        this.reArrangePositionsOrder();
    }

    moveDown(position) {
        if (position.order < this.getCurrentActivePositionsOrdered().length) {
            let oldOrder = position.order;
            _.each(this.getCurrentActivePositionsOrdered(), (curPos) => {
                if (curPos.order === oldOrder + 1) {
                    curPos.order--;
                }
            });
            position.order++;
        }

        this.reArrangePositionsOrder();
    }

    reArrangePositionsOrder() {
        let currentOrder = 1;
        _.each(this.getCurrentActivePositionsOrdered(), (curPos) => {
            curPos.order = currentOrder++;
        });

        this.scope.$applyAsync();
    }

    getCurrentActivePositionsOrdered() {
        return this.filter('orderBy')(this.filter('filter')(this.currentActiveGroup.positions, {enabled: true}), 'order');
    }

    updatePositionBillable(position) {
        position.billable_type = position.billable.type;
        position.billable_id = position.billable.id;
    }
}

CreateModalCtrl.$inject = [
    'Contact',
    '$uibModal',
    '$uibModalInstance',
    'InvoiceTemplate',
    'entity',
    'type',
    '$scope',
    'Invoice',
    '$q',
    'NumberCircle',
    'SweetAlert',
    'Error',
    '$rootScope',
    '$http',
    '$filter',
];

/**
 * @ngdoc object
 * @name billing.invoices.controller:InvoicesCreateModalCtrl
 *
 * @description
 *
 */
angular
    .module('festzelt-os.billing.invoices')
    .controller('InvoicesCreateModalCtrl', CreateModalCtrl);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/controllers/create-modal-controller.js